import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ReserveProvider } from '../providers/reserves';

@Pipe({
    name: 'serviceReserve'
})

export class ServiceReservePipe implements PipeTransform {

    constructor(
        private reserveData: ReserveProvider
    ) { }

    transform(value: string): Observable<any> {
        return this.reserveData.getServicesUserReserve(value);
    }
}



// WEBPACK FOOTER //
// ./src/pipes/service-reserve.pipe.ts